// export const isAutheticated = () => {
//   if (typeof window == "undefined") {
//     return true;
//   }
//   if (localStorage.getItem("auth")) {
//     return JSON.parse(localStorage.getItem("auth"));
//   } else {
//     console.log(JSON.parse(localStorage.getItem("auth")));
//     return false;
//   }
// };


export const isAutheticated = () => {
  if (typeof window === "undefined") {
    return true;
  }

  try {
    const auth = localStorage.getItem("auth");

    if (auth) {
      const parsedAuth = JSON.parse(auth);

      // Check if permissions field exists; if not, add it
      if (!parsedAuth.permissions) {
        parsedAuth.permissions = [];
      }

      // Optionally, add any default permission or modify the structure if needed
      // parsedAuth.permissions.push("default_permission"); // Uncomment if needed

      return parsedAuth;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error parsing auth from localStorage:", error);
    return false;
  }
};

export const signout = () => {
  localStorage.removeItem("auth");
  return true;
};

